import styles from "./AdditionalQuestionsSection.module.css"
import qusetionImg from "../../images/questionImg.png"
import plus from "../../images/plus.webp"
import { useState } from "react"

export default function AdditionalQuestionsSection(){
  const [openedElement, setOpenedElement] = useState(null);
  const handleButtonClick = (elId) => {
    setOpenedElement(openedElement === elId? null: elId)
  }
  return(
    <div className={styles.addQuestSec}>
        <div className={styles.addQuestSec__titleContainer}>
          <img className={styles.addQuestSec__titleImg} src={qusetionImg} alt="Дополнительные вопросы" />
          <h4 className={styles.addQuestSec__title}>Еще остались вопросы по выкупу автомобиля?</h4>
        </div>
        <div className={styles.list}>
          <ul className={styles.list__ul}>

            <li className={styles.list__li} onClick={() => handleButtonClick(1)}>
              <div className={styles.list__liInnerContainer}>
                <p>Почему стоит обратиться в компанию по выкупу авто?</p>
                <button className={styles.list__button}>
                  <img className={styles.list__buttonPlus} src={plus} alt="" />
                </button>
              </div>
              <p className={`${styles.list__text} ${openedElement === 1? styles.list__text_visible : styles.list__text}`}>
                Мы быстро выкупаем авто по честной рыночной цене, берем на себя все юридические вопросы и сразу выплачиваем деньги. 
                Работаем с любыми машинами, в том числе битые, неисправные и кредитные. 
                Экономим ваше время — сами приедем, оценим и оформим сделку без лишних затрат.
              </p>
            </li>
            <li className={styles.list__li} onClick={() => handleButtonClick(2)}>
              <div className={styles.list__liInnerContainer}>
                <p>Как происходит оценка авто?</p>
                <button className={styles.list__button} >
                  <img className={styles.list__buttonPlus} src={plus} alt="" />
                </button>
              </div>
              <p className={`${styles.list__text} ${openedElement === 2? styles.list__text_visible : styles.list__text}`}>
                Вы оставляете заявку с данными авто, после чего мы связываемся с вами и даем предварительную оценку. Далее мы договариваемся с вами о встрече. Эксперт проводит осмотр авто. Учитывается состояние, пробег и рыночная цена. Затем клиент получает предложение, и, если оно его устраивает, оформляется сделка.
              </p>
            </li>
            <li className={styles.list__li} onClick={() => handleButtonClick(3)}>
              <div className={styles.list__liInnerContainer}>
                <p>Сколько времени вам нужно на осомтр автомобиля?</p>
                <button className={styles.list__button}>
                  <img className={styles.list__buttonPlus} src={plus} alt="" />
                </button>
              </div>
              <p className={`${styles.list__text} ${openedElement === 3? styles.list__text_visible : styles.list__text}`}>
                Мы стараемся проводить оценку и заключение сделки по выкупу автомобиля в кратчайшие сроки, обычно это занимает от получаса до одного дня.
              </p>
            </li>
            <li className={styles.list__li} onClick={() => handleButtonClick(4)}>
              <div className={styles.list__liInnerContainer}>
                <p>Что от меня требуется для продажи?</p>
                <button className={styles.list__button}>
                  <img className={styles.list__buttonPlus} src={plus} alt="" />
                </button>
              </div>
              <p className={`${styles.list__text} ${openedElement === 4? styles.list__text_visible : styles.list__text}`}>
              Для успешного приобретения автомобиля необходимо предоставить ряд документов, включая Свидетельство о регистрации транспортного средства (СТС), Паспорт транспортного средства (ПТС) и Ваш паспорт в качестве владельца автомобиля. В случае каких-либо недочетов, свяжитесь с нами для получения консультации.
              </p>
            </li>
            <li className={styles.list__li} onClick={() => handleButtonClick(5)}>
              <div className={styles.list__liInnerContainer}>
                <p>Чем вы лучше конкурентов?</p>
                <button className={styles.list__button}>
                  <img className={styles.list__buttonPlus} src={plus} alt="" />
                </button>
              </div>
              <p className={`${styles.list__text} ${openedElement === 5? styles.list__text_visible : styles.list__text}`}>
              Мы предлагаем честную оценку без занижения цены, быстрое оформление сделки и мгновенную выплату. Выезжаем к клиенту, работаем с любыми авто и берем на себя все юридические вопросы. Никаких скрытых комиссий и долгих ожиданий – просто удобный и выгодный выкуп.
              </p>
            </li>
            <li className={styles.list__li} onClick={() => handleButtonClick(6)}>
              <div className={styles.list__liInnerContainer}>
                <p>Берете ли вы проблемные авто?</p>
                <button className={styles.list__button} >
                  <img className={styles.list__buttonPlus} src={plus} alt="" />
                </button>
              </div>
              <p className={`${styles.list__text} ${openedElement === 6? styles.list__text_visible : styles.list__text}`}>
                Да, мы выкупаем автомобили любых марок и моделей независимо от их состояния — новые, подержанные, аварийные или не прошедшие технический осмотр.
              </p>
            </li>
          </ul>
        </div>
    </div>
  )
}